import { EnhancedCustomer } from "../../../../Models/Customer";
import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import DuplicatesDispositionErrorAlert, {
  IDuplicatesDispositionAlert
} from "../Components/Alerts/DuplicatesDispositionAlert";

/** An error that is shown during dispositioning when:
 * 1. duplicates have been found AND
 * 2. AND the customer isn't yet created
 * 3. AND the customer has valid primary properties and is eligible for creation.
 */
const SessionContextDuplicatesDispositionAlert: React.FC = SessionContextValueProvider<
  IDuplicatesDispositionAlert,
  IDuplicatesDispositionAlert
>({
  Component: DuplicatesDispositionErrorAlert,
  map: ({ isSessionShortCircuited, customer, duplicateCustomers, isSavingCustomer, setShowDuplicateModal }) => ({
    disabled: isSavingCustomer,
    duplicateCustomersCount: duplicateCustomers.length,
    show:
      Boolean(isSessionShortCircuited || !customer.id) &&
      !EnhancedCustomer.getInvalidPrimaryInfoItems(customer).length &&
      Boolean(duplicateCustomers.length),
    onAction: () => setShowDuplicateModal(true)
  })
});

export default SessionContextDuplicatesDispositionAlert;
